@if (eJournal() && !eJournal()?.isFinal &&isPacketSigned() &&
notarizedAuditLoaded()) {
<button
  class="btn btn-success btn-outline normal-case rounded-full h-8 min-h-[32px]"
  (click)="onFinalizeEJournal()"
>
  Finalize
</button>
}

<!-- Finalize eJournal modal template -->
<ng-template #finalizeEJournalModal>
  <div class="flex flex-col gap-6">
    <!-- Header -->
    <div class="flex items-center justify-between">
      <h3 class="flex items-center gap-3 text-lg font-bold">
        Finalize eJournal
      </h3>
      <button class="self-start" mat-dialog-close>
        <img src="assets/icons/close.svg" alt="Close" width="16" height="16" />
      </button>
    </div>
    <!-- Message -->
    <div>
      <p>
        All signers and entries will be locked and cannot be edited or deleted.
      </p>
      <p>
        Only supplemented entries can be added after the eJournal is finalized.
      </p>
    </div>
    <!-- Buttons -->
    <div class="flex justify-center items-center gap-4">
      <button
        matDialogClose
        class="normal-case h-10 min-h-[40px] rounded-full btn btn-outline min-w-[160px] text-base"
        [disabled]="isFinalizing()"
      >
        Cancel
      </button>
      <button
        (click)="finalizeEJournal()"
        [disabled]="isFinalizing()"
        [class.pointer-events-none]="isFinalizing()"
        class="normal-case h-10 min-h-[40px] rounded-full btn btn-primary min-w-[160px] text-base"
      >
        @if(isFinalizing()) {
        <et-atoms-spinner size="small"></et-atoms-spinner>
        } @else { Finalize }
      </button>
    </div>
  </div>
</ng-template>

<!-- Validation errors modal template -->
<ng-template #validationErrorsModal>
  <div class="flex flex-col gap-6">
    <!-- Header -->
    <div class="flex items-center justify-between">
      <h3 class="flex items-center gap-3 text-lg font-bold">
        eJournal validation
      </h3>
      <button class="self-start" mat-dialog-close>
        <img src="assets/icons/close.svg" alt="Close" width="16" height="16" />
      </button>
    </div>
    <!-- Message -->
    <div class="max-h-[400px] overflow-y-auto">
      <p class="mb-4">
        Please resolve the following errors before finalizing the eJournal:
      </p>
      <ul class="list-disc list-inside mb-4">
        @for(error of validationErrors(); track error) {
        <li>{{ error }}</li>
        }
      </ul>
    </div>
    <!-- Buttons -->
    <div class="flex justify-center items-center gap-4">
      <button
        matDialogClose
        class="normal-case h-10 min-h-[40px] rounded-full btn btn-outline min-w-[160px] text-base"
      >
        Close
      </button>
    </div>
  </div>
</ng-template>
